<template>
  <div class="tool1">
    <!-- 导航栏 -->
    <van-nav-bar :border="true" :fixed="true" :placeholder="true" ref="navBar" @click-left="onBack">
      <template #title>
        <span class="title">{{title}}</span>
      </template>
      <template #left>
        <van-icon name="arrow-left" size=".7rem" color="#FF971C" />
      </template>
    </van-nav-bar>
    <!-- 内容 -->
    <!-- 游戏余额 -->
    <section class="balance-wrapper" v-if="id==1">
      <ul>
        <li
          v-for="(item,index) in arrList"
          :key="index"
          @click="childAccountBox('余额',item.gid,item.index)"
        >
          <span>{{item.uname}}</span>
          <span>{{item.game_name}}</span>
          <span>{{item.ubalance}}</span>
        </li>
      </ul>
    </section>
    <!-- 已领取礼包 -->
    <section class="gift-wrapper" v-else-if="id==2">
      <ul>
        <van-list
          v-model="loading"
          :finished="finished"
          finished-text="没有更多了"
          @load="initData"
          :immediate-check="false"
        >
          <div class="gift-block" v-for="(item,index) in arrList" :key="index">
            <div class="game-cont">
              <div class="game-icon-des">
                <div class="i-game">
                  <img v-lazy="item.icon_url" />
                </div>
                <div class="game-des">
                  <div class="game-name-size">
                    <p>{{item.game_name}}</p>
                    <p>{{item.title}}</p>
                  </div>
                </div>
              </div>
              <div class="game-down" v-if="false">
                <a v-if="item.pid!=100" @click.stop="downGame(item.down_url,item.pid,item.gid)">下载</a>
                <a v-else @click.stop="downGame(item.down_url,item.pid,item.gid)">开玩</a>
              </div>
            </div>
            <div class="gift-cont">
              <router-link
                tag="div"
                :to="{name:'giftDetails',query:{id:item.gift_id}}"
                class="gift-des"
              >
                <p class="title">{{item.sub_title}}</p>
                <p class="cont">{{item.summary}}</p>
                <p class="time">{{item.get_time}}</p>
              </router-link>
              <span class="get" @click="copyCode(item.gift_code)">复制礼包码</span>
            </div>
          </div>
        </van-list>
      </ul>
    </section>
    <!-- 充值记录 -->
    <section class="recharge-wrapper" v-else>
      <ul>
        <li
          v-for="(item,index) in arrList"
          :key="index"
          @click="childAccountBox('充值',item.gid)"
        >{{item.game_name}}</li>
      </ul>
    </section>
    <!-- Dialog 弹出框 -->
    <van-dialog v-model="show" title="余额">
      <div class="game-balance">
        <p class="system" v-for="(item,index) in 2" :key="index">
          <span>{{index==1?'安卓':'iOS'}}</span>
          <span>100</span>
        </p>
      </div>
    </van-dialog>
    <!-- 弹出层 -->
    <van-popup v-model="popupShow" position="bottom" :style="{ height: '40%' }">
      <p class="title">请选择</p>
      <div class="accountBox" v-if="this.id==1">
        <p
          v-for="(item,index) in accountList"
          :key="index"
          @click="selectChildAccount('余额',item.ubalance)"
        >
          <span>ID: {{item.uid}}</span>
          <span>用户名: {{item.uname}}</span>
        </p>
      </div>
      <div class="accountBox" v-else-if="this.id==2">
        <router-link
          tag="p"
          :to="{name:'record'}"
          v-for="(item,index) in 10"
          :key="index"
          @click="selectChildAccount(index)"
        >
          <span>QQ2283090111111111</span>
          <span>霸世一服111111111</span>
          <span>大头儿子的故事1111111</span>
        </router-link>
      </div>
      <div class="accountBox" v-else>
        <router-link
          tag="p"
          :to="{name:'record',query:{gameid:item.gid,id:item.uid}}"
          v-for="(item,index) in accountList"
          :key="index"
          @click="selectChildAccount(index)"
        >
          <span>ID: {{item.uid}}</span>
          <span>用户名: {{item.uname}}</span>
        </router-link>
      </div>
    </van-popup>
  </div>
</template>

<script>
import { contTools,lyTool } from "@/mixins/contMixins";
import wapApiFun from "@/servers/wap-module/apiFun";
import comTools from "@/assets/js/until";
export default {
  name: "tool1",
  mixins: [contTools,lyTool],
  components: {},
  data() {
    return {
      id: this.$route.query.id, // 地址栏id
      show: false,
      popupShow: false, // 隐藏弹出层
      popupTitle: "",
      arrList: [],
      accountList: [],
      page: 1,
      loading: false,
      finished: false,
      ubalance: "" // 平台币
    };
  },
  watch: {},
  computed: {
    title: function() {
      switch (true) {
        case this.id == 1:
          return "游戏余额";
          break;
        case this.id == 2:
          return "已领取礼包";
          break;
        case this.id == 3:
          return "充值记录";
          break;
        default:
          return "游戏余额";
          break;
      }
    }
  },
  created() {
    this.initData();
  },
  methods: {
    // 数据初始化
    initData() {
      if (this.id == 1) {
        // 余额
        let data = comTools.assignObj(this.wapConfig(), {
          mobile: this.$cookies.get("mobile"),
          user_token: this.$cookies.get("userToken")
        });
        data.sign = comTools.querySort(data);
        wapApiFun.balanceGame(data).then(res => {
          if (res.code == 200) {
            console.log("游戏余额列表", res);
            this.arrList = res.data.list;
            // this.$toast(res.msg);
          } else {
            this.$toast(res.msg);
          }
        });
      } else if (this.id == 2) {
        // 已领取过的礼包
        let data = comTools.assignObj(this.wapConfig(), {
          mobile: this.$cookies.get("mobile"),
          user_token: this.$cookies.get("userToken"),
          page: this.page
        });
        data.sign = comTools.querySort(data);
        wapApiFun.gotGift(data).then(res => {
          if (res.code == 200) {
            console.log("礼包列表", res);
            let resData = res.data;
            this.arrList = this.arrList.concat(resData.list);
            // 加载状态结束
            this.loading = false;
            // 数据全部加载完成
            if (this.arrList.length >= resData.total) {
              this.finished = true;
            }
            this.page++;
          } else {
            this.$toast("网路出错");
          }
        });
      } else {
        // 充值记录
        let data = comTools.assignObj(this.wapConfig(), {
          mobile: this.$cookies.get("mobile"),
          user_token: this.$cookies.get("userToken")
        });
        data.sign = comTools.querySort(data);
        wapApiFun.payGame(data).then(res => {
          if (res.code == 200) {
            console.log("游戏充值记录", res);
            this.arrList = res.data.list;
          } else {
            this.$toast(res.msg);
          }
        });
      }
    },
    onBack() {
      this.$router.go(-1);
    },
    checkBalance() {
      this.show = true;
    },
    // 选择账号框
    async childAccountBox(type, gid, index) {
      if (type == "余额") {
        let data = comTools.assignObj(this.wapConfig(), {
          mobile: this.$cookies.get("mobile"),
          user_token: this.$cookies.get("userToken"),
          gid: gid
        });
        data.sign = comTools.querySort(data);
        wapApiFun.balanceUser(data).then(res => {
          if (res.code == 200) {
            console.log("游戏账户列表", res);
            this.accountList = res.data.list;
            this.popupShow = true;
            // this.$toast(res.msg);
          } else {
            this.$toast(res.msg);
          }
        });
      } else if (false) {
      } else {
        let data = comTools.assignObj(this.wapConfig(), {
          mobile: this.$cookies.get("mobile"),
          user_token: this.$cookies.get("userToken"),
          gid: gid
        });
        data.sign = comTools.querySort(data);
        wapApiFun.payUser(data).then(res => {
          if (res.code == 200) {
            console.log("充值账户列表", res);
            this.accountList = res.data.list;
            this.popupShow = true;
            // this.$toast(res.msg);
          } else {
            this.$toast(res.msg);
          }
        });
      }
      console.log(gid);
    },
    // 选择账号
    selectChildAccount(type, ubalance) {
      // ubalance
      if (type == "余额") {
        this.$dialog
          .alert({
            title: "平台币",
            message: ubalance
          })
          .then(() => {
            // on close
            this.popupShow = false;
          });
        // let data = comTools.assignObj(this.wapConfig(), {
        //   mobile: this.$cookies.get("mobile"),
        //   user_token: this.$cookies.get("userToken"),
        //   gid: gid,
        //   uid: uid
        // });
        // data.sign = comTools.querySort(data);
        // wapApiFun.gameBalance(data).then(res => {
        //   if (res.code == 200) {
        //     console.log("游戏余额", res);
        //     // this.arrList = res.data.list;
        //     // this.$toast(res.msg);

        //   } else {
        //     this.$toast(res.msg);
        //   }
        // });
      }
    },
    // 复制礼包码
    copyCode(id) {
      console.log("copyCode", id);

      let that = this;
      this.$copyText(id).then(
        function(e) {
          that.$toast("复制成功");
          console.log(e);
          that.show = false;
        },
        function(e) {
          that.$toast("该浏览器不支持自动复制");
          console.log(e);
          that.show = false;
        }
      );
    }
  }
};
</script>
<style lang='less' scoped>
@import "~@/assets/css/com.less";
.tool1 {
  width: 100%;
  min-height: 100vh;
  //  background-color: #ddd;
  .view-bg-color();
  // 导航栏
  .van-nav-bar {
    color: #fff;
    .title,
    .right {
      font-weight: bold;
      // color: #fff;
    }
  }
  // 内容
  .balance-wrapper,
  .recharge-wrapper {
    ul {
      width: 90%;
      margin: 0 auto;
      padding-bottom: 1rem;
      li {
        .font-color();
        padding: 0.3rem 0;
      }
    }
  }
  .gift-wrapper {
    padding: 0 0.6rem;
    // 礼包区块
    .gift-block {
      background-color: #fff;
      .boxShadow(1px);
      .borderRadius(0.5rem);
      // 游戏
      .game-cont {
        .jc-between();
        padding: 0.5rem 0.3rem;
        .game-icon-des {
          display: flex;

          .i-game {
            width: 2rem;
            img {
              .img();
            }
          }
          .game-des {
            .flex-column();
            margin-left: 0.35rem;
            .game-name-size {
              p {
                &:nth-of-type(1) {
                  font-size: 0.5rem;
                }
                &:nth-of-type(2) {
                  .font-color();
                  font-size: 0.3rem;
                }
              }
            }
            .dis-num {
              display: flex;
              margin-top: 0.1rem;
              span {
                color: #fff;
                background-color: #f00;
                font-size: 0.3rem;
                border-radius: 0.2rem;
                display: inline-block;
                padding: 0.03rem 0.2rem;
                margin-right: 0.2rem;
              }
            }
          }
        }
        .game-down {
          .theme-bg-color();
          border-radius: 0.2rem;
          padding: 0.1rem 0.4rem;
          a {
            color: #fff;
          }
        }
        &:first-child {
          margin-top: 0.5rem;
        }
      }
      // 礼包内容
      .gift-cont {
        width: 100%;
        padding: 0.3rem 0;
        padding-top: 0;
        .jc-between();
        .gift-des {
          width: 70%;
          padding-left: 0.3rem;
          p {
            &:nth-of-type(1) {
              font-size: 0.4rem;
            }
            &:nth-of-type(2) {
              font-size: 0.3rem;
              .font-color();
            }
            .ellipsis();
          }
          .time {
            .theme-color();
            font-size: 0.3rem;
          }
        }
        .get,
        .getted {
          border-radius: 0.2rem;
          padding: 0.2rem 0.2rem;
          .theme-bg-color();
          .theme-color();
          color: #fff;
          font-size: 0.35rem;
          margin-right: 0.3rem;
        }
        .getted {
          .font-color();
          border: 1px solid #888;
          padding: 0.1rem 0.2rem;
        }
      }
    }
  }
  .balance-wrapper {
    li {
      // .jc-between();
    }
  }
  .van-dialog {
    .game-balance {
      padding-bottom: 0.5rem;
      .system {
        padding: 0 0.5rem;
        .jc-between();
        // color: ;
      }
    }
  }
  .van-popup {
    .title {
      text-align: center;
      padding: 0.3rem 0;
      border-bottom: 1px solid #e0e0e0;
    }
    .accountBox {
      p {
        .font-color();
        padding: 0.2rem 0;
        text-align: center;
        .jc-around();
        span {
          width: 50%;
          .ellipsis();
          &:nth-of-type(2) {
            text-align: left;
          }
        }
      }
    }
  }
}
</style>